class EqualWidths {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-equal-widths="scope"]',
			item: '[data-equal-widths="item"]',
		}, config);

		this.scopes = document.querySelectorAll(this.config.scope);

		if (this.scopes.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.scopes.forEach((scope) => {
			let timeout = null;

			new ResizeObserver(() => {
				timeout ? clearTimeout(timeout) : null;
				timeout = setTimeout(() => {
					this.removeWidth(scope);
					this.setWidth(scope);
				}, 300);
			}).observe(scope);
		});
	}

	removeWidth(scope) {
		const items = scope.querySelectorAll(this.config.item);
		items.forEach(item => item.style.width = '');
	}

	setWidth(scope) {
		const items = scope.querySelectorAll(this.config.item);
		let width = 0;
		items.forEach(item => {
			const itemWidth = item.offsetWidth;
			if (itemWidth > width) {
				width = itemWidth;
			}
		});
		items.forEach(item => item.style.width = `${width}px`);
	}
}

export default new EqualWidths;
